(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["c1c-web-app-mgmt-console"] = factory();
	else
		root["c1c-web-app-mgmt-console"] = factory();
})(window, function() {
return 